/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Meeesh API
 * The Meeesh API

Rate limiting:
- default: 60 requests/min (applies to all routes).
- write: 60 requests/min (applies to POST/PUT/PATCH/DELETE).
- public: 120 requests/min (applies only to redirect tracker).

Some endpoints may set stricter write limits (e.g., earn start/claim).
On limit, the API returns 429 with a single Retry-After (seconds).
For redirect, clients can include X-Device-Id to ensure device-keyed limits.
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ClaimResultDto,
  FarmingControllerClaim429,
  FarmingControllerStart429,
  FarmingControllerStatus429,
  FarmingStatusDto
} from '.././model';

import { fetcher } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Starts an MP farming session (8h max). If an active session exists, returns its status (idempotent).
 * @summary Start farming session
 */
export const farmingControllerStart = (
    
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<FarmingStatusDto | FarmingStatusDto>(
      {url: `/farming/start`, method: 'POST', signal
    },
      options);
    }
  


export const getFarmingControllerStartMutationOptions = <TError = null | FarmingControllerStart429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof farmingControllerStart>>, TError,void, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof farmingControllerStart>>, TError,void, TContext> => {

const mutationKey = ['farmingControllerStart'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof farmingControllerStart>>, void> = () => {
          

          return  farmingControllerStart(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FarmingControllerStartMutationResult = NonNullable<Awaited<ReturnType<typeof farmingControllerStart>>>
    
    export type FarmingControllerStartMutationError = null | FarmingControllerStart429

    /**
 * @summary Start farming session
 */
export const useFarmingControllerStart = <TError = null | FarmingControllerStart429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof farmingControllerStart>>, TError,void, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof farmingControllerStart>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getFarmingControllerStartMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Returns current session progress if farming is active.
 * @summary Get current farming status
 */
export const farmingControllerStatus = (
    
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<null>(
      {url: `/farming/status`, method: 'GET', signal
    },
      options);
    }
  

export const getFarmingControllerStatusQueryKey = () => {
    return [`/farming/status`] as const;
    }

    
export const getFarmingControllerStatusQueryOptions = <TData = Awaited<ReturnType<typeof farmingControllerStatus>>, TError = null | FarmingControllerStatus429>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof farmingControllerStatus>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFarmingControllerStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof farmingControllerStatus>>> = ({ signal }) => farmingControllerStatus(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: Infinity, retry: 1, retryDelay: 3000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof farmingControllerStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FarmingControllerStatusQueryResult = NonNullable<Awaited<ReturnType<typeof farmingControllerStatus>>>
export type FarmingControllerStatusQueryError = null | FarmingControllerStatus429


export function useFarmingControllerStatus<TData = Awaited<ReturnType<typeof farmingControllerStatus>>, TError = null | FarmingControllerStatus429>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof farmingControllerStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof farmingControllerStatus>>,
          TError,
          Awaited<ReturnType<typeof farmingControllerStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFarmingControllerStatus<TData = Awaited<ReturnType<typeof farmingControllerStatus>>, TError = null | FarmingControllerStatus429>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof farmingControllerStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof farmingControllerStatus>>,
          TError,
          Awaited<ReturnType<typeof farmingControllerStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFarmingControllerStatus<TData = Awaited<ReturnType<typeof farmingControllerStatus>>, TError = null | FarmingControllerStatus429>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof farmingControllerStatus>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current farming status
 */

export function useFarmingControllerStatus<TData = Awaited<ReturnType<typeof farmingControllerStatus>>, TError = null | FarmingControllerStatus429>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof farmingControllerStatus>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFarmingControllerStatusQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Claims accrued MP for the last farming session up to max duration. Idempotent: repeated claims return same amount.
 * @summary Claim farmed points
 */
export const farmingControllerClaim = (
    
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<ClaimResultDto | ClaimResultDto>(
      {url: `/farming/claim`, method: 'POST', signal
    },
      options);
    }
  


export const getFarmingControllerClaimMutationOptions = <TError = null | FarmingControllerClaim429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof farmingControllerClaim>>, TError,void, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof farmingControllerClaim>>, TError,void, TContext> => {

const mutationKey = ['farmingControllerClaim'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof farmingControllerClaim>>, void> = () => {
          

          return  farmingControllerClaim(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FarmingControllerClaimMutationResult = NonNullable<Awaited<ReturnType<typeof farmingControllerClaim>>>
    
    export type FarmingControllerClaimMutationError = null | FarmingControllerClaim429

    /**
 * @summary Claim farmed points
 */
export const useFarmingControllerClaim = <TError = null | FarmingControllerClaim429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof farmingControllerClaim>>, TError,void, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof farmingControllerClaim>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getFarmingControllerClaimMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    